










































import mixins from 'vue-typed-mixins';
import SurveyUtils, { Question, Survey } from '@/utils/SurveyUtils';
import SurveyQuestionForm from '@/components/survey/management/questions/SurveyQuestionForm.vue';
import cloneDeep from 'lodash.clonedeep';
export default mixins().extend({
  components: {
    SurveyQuestionForm,
  },

  props: {
    survey: {
      type: Object as () => Survey,
    },
  },

  computed: {
    surveyOptions(): any {
      return this.surveys?.map((survey) => ({
        text: survey.name.admin,
        value: survey,
      }));
    },
  },

  data(): {
    cloned?: Partial<Question>;
    pristine?: Partial<Question>;
    surveys?: Survey[];
  } {
    return {
      cloned: undefined,
      pristine: undefined,
      surveys: undefined,
    };
  },

  async mounted() {
    try {
      const resp = await SurveyUtils.api.survey.list();
      this.surveys = resp;
      if (this.cloned) {
        this.cloned.survey = this.surveys?.find(
          (survey) => survey.id === this.survey.id
        );
      }
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  methods: {
    async submit() {
      try {
        this.$alert.hide('submit');
        (this.$refs.alert as any).hide('submit');
        if (this.cloned) {
          this.cloned.id = await SurveyUtils.api.question.add(
            this.cloned as Question
          );

          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.add', {
              values: [this.cloned?.questionkey],
            }),
          });

          this.$emit('success', this.cloned);
          (this.$refs.modal as any).resolve();
          this.pristine = undefined;
          this.cloned = undefined;
        }
      } catch (error) {
        (this.$refs.alert as any).show('submit', {
          type: 'error',
          messages: this.$handleAPIError(error, this.$refs.observer),
        });
      }
    },

    cancel() {
      (this.$refs.modal as any).resolve();
      this.pristine = undefined;
      this.cloned = undefined;
    },

    async open(question: Question) {
      this.pristine = question;
      this.cloned = cloneDeep(question);

      if (this.cloned) {
        this.cloned.survey = this.surveys?.find(
          (survey) => survey.id === this.survey.id
        );
      }

      (this.$refs.modal as any).open();
    },
  },
});
